/**
 * Converts an object with dotted path keys (e.g. { "a.b.c": 1 }) into a nested object structure.
 * This is crucial for setDoc with merge: true, as it does not parse dotted paths
 * and instead writes them as literal field names containing dots.
 */
export function nestObject(updates: Record<string, unknown>): Record<string, unknown> {
  const nested: Record<string, unknown> = {};
  Object.entries(updates).forEach(([key, value]) => {
    const parts = key.split('.');
    let current = nested;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!(parts[i] in current) || typeof current[parts[i]] !== 'object' || current[parts[i]] === null) {
        current[parts[i]] = {};
      }
      current = current[parts[i]] as Record<string, unknown>;
    }
    current[parts[parts.length - 1]] = value;
  });
  return nested;
}
